import clsx from 'clsx';
import { useState, type ReactNode } from 'react';

import { Skeleton } from '@flintmint/web-shared/components/skeleton';
import { ProgressiveBlur } from '@flintmint/web-shared/components/progressive-blur';

import styles from './context-item.module.scss';

export const ImagePreview = (props: ImagePreviewProps) => {
  const { name, hasActions, meta, actions, previewUrl, uploadStatus, onLoadError } = props;
  const [isImageReady, setIsImageReady] = useState(false);

  return (
    <div className={styles.imagePreviewHolder}>
      <div className={styles.imagePreviewSkeleton} data-testid="context-item-image-skeleton">
        <Skeleton trueWidth="100%" trueHeight="100%" borderRadius={0} />
      </div>
      {!!previewUrl && (
        <img
          alt={name}
          src={previewUrl}
          loading="lazy"
          decoding="async"
          className={styles.imagePreview}
          onLoad={() => setIsImageReady(true)}
          onError={() => {
            setIsImageReady(false);
            onLoadError?.();
          }}
        />
      )}
      {isImageReady && <ProgressiveBlur position="top" intensity={60} bottom={50} />}
      <div className={clsx(styles.content, styles.imagePreviewInfo)}>
        {meta}
        {!uploadStatus && hasActions && <div className={styles.headerActions}>{actions}</div>}
      </div>
    </div>
  );
};

interface ImagePreviewProps {
  name: string;
  meta: ReactNode;
  actions: ReactNode;
  previewUrl?: string;
  hasActions: boolean;
  onLoadError?: () => void;
  uploadStatus?: 'uploading' | 'error';
}
